import { render, staticRenderFns } from "./WcTablesFooter.vue?vue&type=template&id=5fe7bd37&lang=pug&"
import script from "./WcTablesFooter.vue?vue&type=script&lang=js&"
export * from "./WcTablesFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports